import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { UserChapter } from "../../interfaces/firebase-interfaces";

@Component({
  selector: "app-bit",
  templateUrl: "./bit.component.html",
  styleUrls: ["./bit.component.scss"],
})
export class BitComponent implements OnInit {
  @Input() bit: UserChapter;
  @Input() innerId: string;
  @Input() outerId: string;
  @Input() outerLevel: "Part" | "Whole";

  @Output("presentOptions") presentOptions: EventEmitter<any> = new EventEmitter<any>();

  constructor(private router: Router) {}

  ngOnInit() {}

  async viewChapter(bit: UserChapter) {
    if (bit.id) {
      let navigationExtras: NavigationExtras = {
        state: {
          showPreview: false,
        },
        queryParams: {
          offset: bit.originalChapterId,
        },
      };
      if (this.outerLevel == "Whole") {
        this.router.navigate([`/r/${this.outerId}/user-set/${this.innerId}`], navigationExtras);
      } else if (this.outerLevel == "Part") {
        this.router.navigate([`/r/${this.outerId}/user-book/${this.innerId}`], navigationExtras);
      } else {
        this.router.navigate([`/r/${bit.libraryId}/chapter/${bit.originalChapterId}`], navigationExtras);
      }
    } else {
      console.error("content id not found", bit);
    }
  }
}
